<panel width="500">
  <menu always-visible>
    <menuitem *requiredCredential="credentialType.StartProductPlanManually" (click)="startPlan()">{{ 'microsoft365.force-start-of-plan' | translate }}</menuitem>
  </menu>
  <h1>{{ productPlanSubscription.productPlan | productName }}</h1>
  @if (loading) {
    <skeleton />
  }
  @if (!loading) {
    <section>
      <custom-select (valueChange)="updateSubscriptionInitialOrderData($event)"
        [(value)]="selectedSubscriptionProductId"
        [label]="'microsoft365.select-subscription-product' | translate"
        [selectList]="crayonProductsSelectList"
        [placeholder]="'microsoft365.select-subscription-product-placeholder' | translate">
      </custom-select>
    </section>
  }
  @if (selectedSubscriptionProductId) {
    <section one-column>
      {{ 'microsoft365.initial-order-data-ready' | translate }}
    </section>
  }
</panel>
